import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "relative z-50" }
const _hoisted_2 = { class: "bg-primary px-4 py-1 h-16 flex flex-row items-center relative" }
const _hoisted_3 = { class: "container mx-auto flex flex-row items-center justify-between" }
const _hoisted_4 = { class: "flex flex-row items-center" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "",
  class: "h-10 crisp"
}, null, -1)
const _hoisted_6 = { class: "rounded-full bg-white" }
const _hoisted_7 = { class: "text-white ml-4 mr-2 my-0 ellipsis max-w-32 hidden sm:block" }
const _hoisted_8 = { class: "hidden sm:block" }
const _hoisted_9 = {
  key: 0,
  class: "bg-primary block sm:hidden px-4 py-2 absolute w-full z-10"
}
const _hoisted_10 = { class: "ml-2" }
const _hoisted_11 = { class: "bg-white shadow-sm hidden sm:block" }
const _hoisted_12 = { class: "container mx-auto flex flex-row" }
const _hoisted_13 = { class: "ml-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MenuIcon = _resolveComponent("MenuIcon")
  const _component_CloseIcon = _resolveComponent("CloseIcon")
  const _component_UserCircleIcon = _resolveComponent("UserCircleIcon")
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")
  const _component_SubNavItems = _resolveComponent("SubNavItems")
  const _component_SubNav = _resolveComponent("SubNav")
  const _component_Link = _resolveComponent("Link")

  return (_openBlock(), _createBlock("nav", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          (!_ctx.showMobileNav)
            ? _createVNode(_component_MenuIcon, {
                key: 0,
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.showMobileNav = true)),
                class: "block sm:hidden cursor-pointer h-8 mr-2 w-8 text-white focus:bg-dark-primary active:bg-dark-primary rounded p-1 outline-none"
              })
            : _createCommentVNode("", true),
          (_ctx.showMobileNav)
            ? _createVNode(_component_CloseIcon, {
                key: 1,
                onClick: _cache[2] || (_cache[2] = $event => (_ctx.showMobileNav = false)),
                class: "block sm:hidden cursor-pointer h-8 mr-2 w-8 text-white focus:bg-dark-primary active:bg-dark-primary rounded p-1 outline-none"
              })
            : _createCommentVNode("", true),
          _hoisted_5
        ]),
        _createVNode(_component_SubNav, null, {
          default: _withCtx(() => [
            _createVNode("button", {
              class: ["flex text-sm border-2 focus:outline-none transition duration-300 ease rounded-full p-2", {
							'border-white': _ctx.buttonSelected,
							'border-primary': !_ctx.buttonSelected,
						}],
              id: "user-menu",
              "aria-label": "User menu",
              "aria-haspopup": "true",
              onBlur: _cache[3] || (_cache[3] = $event => (_ctx.resetSelected())),
              onClick: _cache[4] || (_cache[4] = $event => (_ctx.toggleSelected()))
            }, [
              _createVNode("span", _hoisted_6, [
                _createVNode(_component_UserCircleIcon, { class: "h-6 w-6 text-primary" })
              ]),
              _createVNode("span", _hoisted_7, _toDisplayString(_ctx.fullName), 1),
              _createVNode("span", _hoisted_8, [
                _createVNode(_component_ChevronDownIcon, {
                  class: ["transform transition duration-300 h-6 w-6 text-white", {
									'rotate-180': _ctx.buttonSelected,
									'rotate-0': !_ctx.buttonSelected,
								}]
                }, null, 8, ["class"])
              ])
            ], 34),
            _createVNode(_component_SubNavItems, {
              items: _ctx.profileLinks,
              show: _ctx.showSubNav
            }, null, 8, ["items", "show"])
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.showMobileNav)
      ? (_openBlock(), _createBlock("div", _hoisted_9, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.menu, (item, index) => {
            return (_openBlock(), _createBlock(_component_Link, {
              key: index,
              "link-type": "inverted",
              "link-to": item.link
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "w-4 h-4" })),
                _createVNode("span", _hoisted_10, _toDisplayString(item.label), 1)
              ]),
              _: 2
            }, 1032, ["link-to"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_11, [
      _createVNode("div", _hoisted_12, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.menu, (item, index) => {
          return (_openBlock(), _createBlock(_component_Link, {
            key: index,
            "link-to": item.link
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "w-4 h-4" })),
              _createVNode("span", _hoisted_13, _toDisplayString(item.label), 1)
            ]),
            _: 2
          }, 1032, ["link-to"]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}